import { Component, OnInit } from '@angular/core';
import { AuthService } from '@lciapps/auth';

@Component({
  selector: 'app-auth-nav',
  template: `
    <p>
      <a routerLink="/root/protected" href>Secure Area</a><span *ngIf="loggedIn"> | </span>
      <a href (click)="signout()" *ngIf="loggedIn">Sign Out</a>
    </p>
  `
})
export class AuthNavComponent implements OnInit {
  loggedIn = false;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.authService.loggedIn$.subscribe(isLoggedIn => {
      this.loggedIn = isLoggedIn;
    });
  }

  signout() {
    this.authService.startSignoutMainWindow();
  }
}
